// extracted by mini-css-extract-plugin
export default {"mobileIndustry":"CxkZmzNDtM8tla0Imjng","error":"zB8ftuVCV9Ew5wRMFLKZ"};